$(document).ready(function(){
  $('body').on('change', '.custom-checkbox', function(){
    var id = $(this).attr('id');
    $('.custom-size-content[data-contents='+id+']').toggle();
  });
  if ($('#custom-agreement').length > 0) {
    $('.add-to-cart').attr('disabled', true);
  } else {
    $('.add-to-cart').removeAttr('disabled');
  }
  $('body').on('change', '#custom-agreement', function(){
    if($(this).is(":checked")){
      $('.add-to-cart').removeAttr('disabled')
    } else {
      $('.add-to-cart').attr('disabled', true)
    }
  });
  
  if($('#shipping-date').length > 0){
  	//get Date, parseInt value shipping date terus add ke currentDate, convert ke human time
    var newDate = new Date();
    var shippingDays = parseInt($('#shipping-date').text());
    var monthNames = ["January", "February", "March", "April", "May", "June",
                      "July", "August", "September", "October", "November", "December"];
    newDate.setDate(newDate.getDate() + shippingDays)
	var newDateFormat = monthNames[newDate.getMonth()] + ' ' + newDate.getDate() + ', ' + newDate.getFullYear();
  	$('#shipping-date').text(newDateFormat);
  }
  
  function announcementHeight(){
  	$('.announcement_bar_v2').height($('.ab_container').height());
  }
  announcementHeight();
  $(window).on('resize', function(){
    announcementHeight();
  });
  
  $('.ab_container.with_popup,.ab_open_popup').click(function(e){
    if(event.target.tagName.toLowerCase() === 'a'){
      var href = event.target.href;
      window.location = href;
    }else{
      $('body').addClass('locked');
      $('.ab_popup').addClass('opened');
    }
  });
  $('.ab_popup_close').click(function(){
    $('.ab_popup').removeClass('opened');
    $('body').removeClass('locked');
  });
  
  
  $('.size-chart-link').fancybox({
    afterLoad : function() {
      var vid = this.$content.find('video')[0];
      $(this.$content).parent().addClass('size-chart-popup');
      var checkVideo = setInterval(function () {
        var isPlaying = vid.currentTime > 0 && !vid.paused && !vid.ended && vid.readyState > vid.HAVE_CURRENT_DATA;
        if(isPlaying){
          vid.pause();
          clearInterval(checkVideo);
        }
      }, 200);
    }
  });
  
  $(document).on('click','.size-chart-toggle .sc-category-toggle', function(){
    $(this).addClass('active').siblings().removeClass('active');
    var target = $(this).attr('data-target');
    $('.sc-table span').each(function(){
      if($(this).attr('data-id') == target){
        $(this).removeClass('inactive');
      }else{
        $(this).addClass('inactive');
      }
    })
  })
  
  $(document).on('change','.unit_switch input', function(){
    if($(this).is(':checked')){
      $('.sc-table-unit div:last-child').show();
      $('.sc-table-unit div:first-child').hide();
    }else{
      $('.sc-table-unit div:last-child').hide();
      $('.sc-table-unit div:first-child').show();
    }
  });
  
  
  $(document).on('change','input[type="number"]',function() {
    var max = parseInt($(this).attr('max'));
    var min = parseInt($(this).attr('min'));
    if ($(this).val() > max){
      $(this).val(max);
    }else if ($(this).val() < min){
      $(this).val(min);
    }       
   }); 
  
  if($('.adaptive-size-chart-table').length){
    var page_url = $('.adaptive-size-chart-table').attr('data-url');
    $('.adaptive-size-chart-table').load(page_url+" .sc-table-wrapper");

  }
  
  $(document).on('change', '.custom-field-wrapper [name="properties[Size]"]', function(){
    var val = $(this).find('option:selected').attr('data-size-chart');
    var selectedTr = $('.adaptive-size-chart-table table tr[data-size="'+val+'"]');
    if(selectedTr.length){
      $('.adaptive-size-chart-table').addClass('show');
      $('.adaptive-size-chart-table table tr').removeClass('active show');
      selectedTr.addClass('active');
      if(selectedTr.is(':first-child')){
        $('.adaptive-size-chart-table table tr[data-size="'+val+'"]').next().addClass('show');
        $('.adaptive-size-chart-table table tr[data-size="'+val+'"]').next().next().addClass('show');
      }else if(selectedTr.is(':last-child')){
        $('.adaptive-size-chart-table table tr[data-size="'+val+'"]').prev().addClass('show');
        $('.adaptive-size-chart-table table tr[data-size="'+val+'"]').prev().prev().addClass('show');
      }else{
        $('.adaptive-size-chart-table table tr[data-size="'+val+'"]').prev().addClass('show');
        $('.adaptive-size-chart-table table tr[data-size="'+val+'"]').next().addClass('show');
      }
    }else{
      $('.adaptive-size-chart-table').removeClass('show');
    }
  });
  
});



(function() {
  function initArrows() {
    // Find the slider by its ID pattern or class
    const sliderContainer = document.querySelector('.product__thumbs.slick-initialized.slick-slider.slick-vertical');
    
    if (!sliderContainer) {
      console.log('Slider not found yet, retrying...');
      return false;
    }
    
    // Check if arrows already exist
    if (sliderContainer.parentNode.querySelector('.vertical-slider-arrow')) {
      console.log('Arrows already exist');
      return true;
    }
    
    console.log('Found slider, adding arrows...');
    
    // Create wrapper if parent doesn't have one
    const parent = sliderContainer.parentNode;
    
    // Create arrow buttons
    const arrowUp = document.createElement('button');
    arrowUp.className = 'vertical-slider-arrow arrow-up';
    arrowUp.type = 'button';
    arrowUp.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0902/2000/files/up-arrow.png?v=1768461297">';
    
    const arrowDown = document.createElement('button');
    arrowDown.className = 'vertical-slider-arrow arrow-down';
    arrowDown.type = 'button';
    arrowDown.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0902/2000/files/down-arrow.png?v=1768461266">';
    
    // Insert arrows around the slider
    parent.insertBefore(arrowUp, sliderContainer);
    parent.appendChild(arrowDown);
    
    // Get jQuery slider instance
    const $slider = jQuery(sliderContainer);
    
    // Arrow click handlers
    arrowUp.addEventListener('click', function(e) {
      e.preventDefault();
      $slider.slick('slickPrev');
    });
    
    arrowDown.addEventListener('click', function(e) {
      e.preventDefault();
      $slider.slick('slickNext');
    });
    
    // Update arrow states based on slider position
    function updateArrowStates() {
      try {
        const slickInstance = $slider.slick('getSlick');
        const currentSlide = slickInstance.currentSlide;
        const slideCount = slickInstance.slideCount;
        const slidesToShow = slickInstance.options.slidesToShow;
        
        // Disable/enable arrows
        arrowUp.disabled = currentSlide === 0;
        arrowDown.disabled = currentSlide >= slideCount - slidesToShow;
        
        console.log('Current:', currentSlide, 'Total:', slideCount, 'ToShow:', slidesToShow);
      } catch(e) {
        console.log('Error updating arrows:', e);
      }
    }
    
    // Listen to slider events
    $slider.on('afterChange', function(event, slick, currentSlide) {
      updateArrowStates();
    });
    
    // Initial state
    updateArrowStates();
    
    console.log('Arrows initialized successfully!');
    return true;
  }
  
  // Try to initialize multiple times
  function tryInit() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(initArrows, 100);
        setTimeout(initArrows, 500);
        setTimeout(initArrows, 1000);
        setTimeout(initArrows, 2000);
      });
    } else {
      setTimeout(initArrows, 100);
      setTimeout(initArrows, 500);
      setTimeout(initArrows, 1000);
      setTimeout(initArrows, 2000);
    }
  }
  
  tryInit();
  
  // Also listen for Shopify section reloads
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initArrows, 300);
  });
})();



const womensData = {
    in: [
        { size: '2XS', height: '58.3-59.8"', bust: '29.9-30.7"', waist: '22.4-23.2"', hip: '33.1-33.9"', tolerance: '+/- 0.5 inch' },
        { size: 'XS', height: '60.2-61.8"', bust: '31.1-31.9"', waist: '23.6-24.4"', hip: '34.3-35.0"', tolerance: '+/- 0.5 inch' },
        { size: 'S', height: '62.2-63.8"', bust: '32.3-33.1"', waist: '24.8-25.6"', hip: '35.4-36.2"', tolerance: '+/- 0.5 inch' },
        { size: 'M', height: '64.2-65.7"', bust: '33.5-34.3"', waist: '26.0-26.8"', hip: '36.6-37.4"', tolerance: '+/- 0.5 inch' },
        { size: 'L', height: '66.1-67.7"', bust: '34.6-35.4"', waist: '27.2-28.0"', hip: '37.8-38.6"', tolerance: '+/- 0.5 inch' },
        { size: 'XL', height: '68.1-69.7"', bust: '35.8-36.6"', waist: '28.3-29.1"', hip: '39.0-39.8"', tolerance: '+/- 0.5 inch' },
        { size: '2XL', height: '70.1-71.7"', bust: '37.0-37.8"', waist: '29.5-30.3"', hip: '40.2-40.9"', tolerance: '+/- 0.5 inch' },
        { size: '3XL', height: '72.0-73.6"', bust: '38.2-39.0"', waist: '30.7-31.5"', hip: '41.3-42.1"', tolerance: '+/- 0.5 inch' }
    ],
    cm: [
        { size: '2XS', height: '148-152CM', bust: '76-78CM', waist: '57-59CM', hip: '84-86CM', tolerance: '+/- 0.5 inch' },
        { size: 'XS', height: '153-157CM', bust: '79-81CM', waist: '60-62CM', hip: '87-89CM', tolerance: '+/- 0.5 inch' },
        { size: 'S', height: '158-162CM', bust: '82-84CM', waist: '63-65CM', hip: '90-92CM', tolerance: '+/- 0.5 inch' },
        { size: 'M', height: '163-167CM', bust: '85-87CM', waist: '66-68CM', hip: '93-95CM', tolerance: '+/- 0.5 inch' },
        { size: 'L', height: '168-172CM', bust: '88-90CM', waist: '69-71CM', hip: '96-98CM', tolerance: '+/- 0.5 inch' },
        { size: 'XL', height: '173-177CM', bust: '91-93CM', waist: '72-74CM', hip: '99-101CM', tolerance: '+/- 0.5 inch' },
        { size: '2XL', height: '178-182CM', bust: '94-96CM', waist: '75-77CM', hip: '102-104CM', tolerance: '+/- 0.5 inch' },
        { size: '3XL', height: '183-187CM', bust: '97-99CM', waist: '78-80CM', hip: '105-107CM', tolerance: '+/- 0.5 inch' }
    ]
};

const mensData = {
    in: [
        { size: '2XS', height: '60.2-61.8"', bust: '33.1-33.9"', waist: '28.3-29.1"', hip: '33.5-34.3"', tolerance: '+/- 0.5 inch' },
        { size: 'XS', height: '62.2-63.8"', bust: '34.3-35.0"', waist: '29.5-30.3"', hip: '34.6-35.4"', tolerance: '+/- 0.5 inch' },
        { size: 'S', height: '64.2-65.7"', bust: '35.4-36.2"', waist: '30.7-31.5"', hip: '35.8-36.6"', tolerance: '+/- 0.5 inch' },
        { size: 'M', height: '66.1-67.7"', bust: '36.6-37.4"', waist: '31.9-32.7"', hip: '37.0-37.8"', tolerance: '+/- 0.5 inch' },
        { size: 'L', height: '68.1-69.7"', bust: '37.8-38.6"', waist: '33.1-33.9"', hip: '38.2-39.0"', tolerance: '+/- 0.5 inch' },
        { size: 'XL', height: '70.1-71.7"', bust: '39.0-39.8"', waist: '34.3-35.0"', hip: '39.4-40.2"', tolerance: '+/- 0.5 inch' },
        { size: '2XL', height: '72.0-73.6"', bust: '40.2-40.9"', waist: '35.4-36.2"', hip: '40.6-41.3"', tolerance: '+/- 0.5 inch' },
        { size: '3XL', height: '74.0-75.6"', bust: '41.3-42.1"', waist: '36.6-37.4"', hip: '41.7-42.5"', tolerance: '+/- 0.5 inch' }
    ],
    cm: [
        { size: '2XS', height: '153-157CM', bust: '84-86CM', waist: '72-74CM', hip: '85-87CM', tolerance: '+/- 0.5 inch' },
        { size: 'XS', height: '158-162CM', bust: '87-89CM', waist: '75-77CM', hip: '88-90CM', tolerance: '+/- 0.5 inch' },
        { size: 'S', height: '163-167CM', bust: '90-92CM', waist: '78-80CM', hip: '91-93CM', tolerance: '+/- 0.5 inch' },
        { size: 'M', height: '168-172CM', bust: '93-95CM', waist: '81-83CM', hip: '94-96CM', tolerance: '+/- 0.5 inch' },
        { size: 'L', height: '173-177CM', bust: '96-98CM', waist: '84-86CM', hip: '97-99CM', tolerance: '+/- 0.5 inch' },
        { size: 'XL', height: '178-182CM', bust: '99-101CM', waist: '87-89CM', hip: '100-102CM', tolerance: '+/- 0.5 inch' },
        { size: '2XL', height: '183-187CM', bust: '102-104CM', waist: '90-92CM', hip: '103-105CM', tolerance: '+/- 0.5 inch' },
        { size: '3XL', height: '188-192CM', bust: '105-107CM', waist: '93-95CM', hip: '106-108CM', tolerance: '+/- 0.5 inch' }
    ]
};

let currentUnit = 'in';

function renderTable(tableId, data) {
    const table = document.getElementById(tableId);
    if (!table) {
        console.error('Table not found:', tableId);
        return;
    }
    
    const unit = currentUnit === 'in' ? 'Inch' : 'CM';
    
    const tbody = table.querySelector('tbody');
    const thead = table.querySelector('thead tr');
    
    if (!tbody || !thead) {
        console.error('Table body or head not found');
        return;
    }
    
    // Update header
    thead.innerHTML = `
        <th>Size</th>
        <th>Height (${unit})</th>
        <th>Bust (${unit})</th>
        <th>Waist (${unit})</th>
        <th>Hip (${unit})</th>
        <th>Tolerance</th>
    `;
    
    // Update body
    tbody.innerHTML = data.map(row => `
        <tr>
            <td><strong>${row.size}</strong></td>
            <td>${row.height}</td>
            <td>${row.bust}</td>
            <td>${row.waist}</td>
            <td>${row.hip}</td>
            <td>${row.tolerance}</td>
        </tr>
    `).join('');
}

function toggleUnit(unit) {
    currentUnit = unit;
    
    const btnIn = document.getElementById('btn-in');
    const btnCm = document.getElementById('btn-cm');
    
    if (!btnIn || !btnCm) {
        console.error('Buttons not found');
        return;
    }
    
    // Remove active class from both buttons
    btnIn.classList.remove('active');
    btnCm.classList.remove('active');
    
    // Add active class to clicked button
    if (unit === 'in') {
        btnIn.classList.add('active');
    } else {
        btnCm.classList.add('active');
    }
    
    // Update tables
    renderTable('womens-table', womensData[unit]);
    renderTable('mens-table', mensData[unit]);
}

// Initialize the page when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
    // Render initial tables
    renderTable('womens-table', womensData[currentUnit]);
    renderTable('mens-table', mensData[currentUnit]);
    
    // Add click event listeners to buttons
    document.getElementById('btn-in').addEventListener('click', function() {
        toggleUnit('in');
    });
    
    document.getElementById('btn-cm').addEventListener('click', function() {
        toggleUnit('cm');
    });
});